import projectSchedule202611 from "@/assets/whatsNew/2026-11/projectSchedule.png";
import debtConfession202611 from "@/assets/whatsNew/2026-11/debtConfession.png";
import approvalFlowBuilder202611 from "@/assets/whatsNew/2026-11/approvalFlowBuilder.png";
import pathologyHistory202611 from "@/assets/whatsNew/2026-11/pathologyHistory.png";
import appTutorial202611 from "@/assets/whatsNew/2026-11/appTutorial.png";

export interface IWhatsNewHighlight {
  title: string;
  description: string;
  location?: string;
}

export interface IWhatsNewSlide {
  title: string;
  location?: string;
  paragraphs?: string[];
  image?: { src: string; alt: string };
  highlights?: IWhatsNewHighlight[];
}

export interface IWhatsNewRelease {
  /** Identifica a versão no localStorage; trocar o id faz o modal abrir de novo para todos. */
  id: string;
  title: string;
  version: string;
  slides: IWhatsNewSlide[];
}

/** Histórico das novidades, da release mais nova para a mais antiga. */
export const releases: IWhatsNewRelease[] = [
  {
    id: "2026-11",
    title: "Novidades de novembro",
    version: "2.2.0",
    slides: [
      {
        title: "Gerenciamento de Obras",
        location: "Novo módulo · Gerenciamento de Obras → Obras",
        paragraphs: [
          "Acompanhe cada obra do início ao fim: etapas, cronograma, custos, recebimentos, arquivos e ocorrências no mesmo lugar.",
          "O Portfólio reúne todas as obras num Gantt, com a saúde de cada uma, a carga por responsável e o que vence nos próximos dias.",
        ],
        image: {
          src: projectSchedule202611,
          alt: "Cronograma de uma obra com as etapas Licenciamento, Fundação, Montagem da torre e Energização ligadas por dependências",
        },
      },
      {
        title: "Confissão de Dívida",
        location: "Financeiro → Confissões de Dívida",
        paragraphs: [
          "Na listagem de lançamentos, selecione os lançamentos do cliente e clique em Criar confissão. Defina desconto, acréscimo e o plano de parcelas.",
          "Cada confissão mostra parcelas, origens e o histórico de baixas, e pode ser exportada em PDF.",
        ],
        image: {
          src: debtConfession202611,
          alt: "Tela da confissão de dívida, aba Parcelas, com quatro parcelas em aberto e o botão Exportar dívida",
        },
      },
      {
        title: "Novo construtor de fluxos de aprovação",
        location: "Gerenciamento de Torres → Aprovações → Fluxos de Aprovação",
        paragraphs: [
          "Monte e edite o fluxo inteiro pela tela. As alterações ficam em rascunho até você salvar, e o sistema aponta o que está errado em cada etapa antes de gravar.",
          "Cada alteração pode virar uma nova versão do fluxo, e etapas removidas ficam arquivadas sem perder o histórico.",
        ],
        image: {
          src: approvalFlowBuilder202611,
          alt: "Construtor de fluxos com as etapas Solicitação, Coordenação do serviço e Aprovação da gerência, ligadas por setas de aprovação e de retorno",
        },
      },
      {
        title: "Patologias com histórico de versões",
        location: "Atividade ou site → aba Patologias",
        paragraphs: [
          "Cada patologia ganha um cartão com a linha do tempo das versões. Separe as resolvidas das não resolvidas e filtre por severidade e local.",
          "Agora uma patologia pode ter várias fotos, e os cartões mostram quais patologias estão vinculadas entre si.",
        ],
        image: {
          src: pathologyHistory202611,
          alt: "Cartão de uma patologia de corrosão com a linha do tempo das versões: registro inicial e nova foto lançada",
        },
      },
      {
        title: "Tutorial do aplicativo de campo",
        location: "Gerenciamento de Torres → Tutorial do App",
        paragraphs: [
          "Um passo a passo do app, do login ao envio dos formulários, incluindo o uso sem internet, com perguntas frequentes e busca.",
          "Bom para enviar a quem está começando no campo.",
        ],
        image: {
          src: appTutorial202611,
          alt: "Página Tutorial do aplicativo, com busca, índice lateral e o passo 1, Primeiro acesso e permissões",
        },
      },
      {
        title: "E mais",
        highlights: [
          {
            title: "Tipos de Ocorrência",
            description:
              "Crie tipos de ocorrência e os motivos de cada um pela tela, sem depender do time de TI.",
            location:
              "Gerenciamento de Torres → Cadastros → Tipos de Ocorrências",
          },
          {
            title: "Terceirizadas e clientes integrados ao Financeiro",
            description:
              "Cadastrar ou editar uma terceirizada ou um cliente atualiza o cliente/fornecedor no Financeiro. Os campos replicados avisam antes de salvar.",
          },
          {
            title: "Categoria gerencial nas automações",
            description:
              "Os lançamentos gerados automaticamente já nascem com a categoria gerencial escolhida na configuração de cada automação.",
          },
        ],
      },
    ],
  },
];

/** Release exibida no modal: sempre a primeira da lista. */
export const currentRelease: IWhatsNewRelease = releases[0];
